import { render, staticRenderFns } from "./Recording.vue?vue&type=template&id=1a84e4a7&"
import script from "./Recording.vue?vue&type=script&lang=js&"
export * from "./Recording.vue?vue&type=script&lang=js&"
import style0 from "./Recording.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a84e4a7')) {
      api.createRecord('1a84e4a7', component.options)
    } else {
      api.reload('1a84e4a7', component.options)
    }
    module.hot.accept("./Recording.vue?vue&type=template&id=1a84e4a7&", function () {
      api.rerender('1a84e4a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Recording.vue"
export default component.exports